/* Component Dependencies */
var offerNextGenCardsTemplate = require('templates/offerNextGenCards.hbs');
var offerNextGenCardsSearchResultsTemplate = require('templates/offerNextGenCards-searchResults.hbs');
var offerNextGenMEOAndOffersTemplate = require('templates/offerNextGenMEOAndOffers.hbs');
var offerNextGenCardsV2Template = require('templates/offerNextGenCardsV2.hbs');
var AriesComponent = require('libs/aries-component');
var mobileFirstPicture = require('offers_libs/mobileFirstPicture');
require('libs/jquery.dotdotdot');

AriesComponent.create({
  type: 'offerNextGenCards',
  template: {
    'offerNextGenCards': offerNextGenCardsTemplate,
    'offerNextGenCards-searchResults': offerNextGenCardsSearchResultsTemplate,
    'offerNextGenMEOAndOffers': offerNextGenMEOAndOffersTemplate,
    'offerNextGenCardsV2': offerNextGenCardsV2Template
  },
  events: {
    'click .js-card-link': 'creditCardPanelClick',
    'click .slick-arrow': 'handleTabIndex',
    'mouseover .m-card-wrapper': 'handleTabIndex',
    'click .js-show-more': 'moreOffers'
  },
  bindEvents: function($) { 
    var _self = this; 
    _self.parentSelector = $('[data-component-id="' + _self.componentId + '"]');
    _self.$carousel = _self.parentSelector.find('.mi-carousel');

    var dlImages = (window.InstallTrigger && typeof window.InstallTrigger !== 'undefined') || !!document.documentMode;

    if(dlImages) {
      var cards = $('[data-component-id="' + _self.componentId + '"]').find('.js-offer-card');
      cards.each(function() {
        var picElem = $(this).find('picture');
        var imgElem = $(this).find('img');
        var imgSrc = imgElem[0].dataset.lazy;
        if(picElem.hasClass('mi-lazyLoadImage')) {
          picElem.removeClass('mi-lazyLoadImage');
        }
        imgElem.removeAttr('data-src');
        imgElem.removeAttr('data-lazy');
        imgElem[0].src = imgSrc;
      });
    }
    
    if (_self.parentSelector.find('.slick-initialized').length) {
      _self.onSlickInit.call(_self);
    }
    else if (_self.$carousel && _self.$carousel.length > 0) { 
      _self.$carousel.on('init', function() {
        _self.onSlickInit.call(_self);
      });
    }

    if(_self.$carousel.length === 0) {
      mobileFirstPicture.init(_self);
      _self.setGradient(_self);
    }

    this.$el.find('.js-offer-info').dotdotdot({
      wrap: 'word',
      ellipsis: "\u2026 ",
      watch: window
    });

    this.$el.find(".details-wrapper h2, .details-wrapper p, .card-content-wrapper p").dotdotdot({
      wrap: 'word',
      ellipsis: "\u2026 ",
      watch: window
    });
  },
  subscribe: {
    'WINDOW_LOAD_EVENT': 'handleTabIndex'
  },
  onSlickInit: function _onSlickInit() {
    var _self = this;
    var carousel = $('[data-component-id="' + _self.componentId + '"]').find('.mi-carousel');
    setTimeout(function() {
      var slidesToScroll = parseInt(carousel.attr('data-slides-to-show'));
      if ($('[data-component-id="' + _self.componentId + '"]').hasClass('m-offers-four-pack-list')) {
        carousel.slick('slickSetOption', {
          responsive: [
            {
              breakpoint: 10000,
              settings: "unslick"
            }
          ]
        }, true);
      }
      else {
        carousel.slick('slickSetOption', {
          slidesToScroll: slidesToScroll
        }, true);
      }
      mobileFirstPicture.init(_self);
      _self.setGradient(_self);
    }.bind(this));
  },
  setGradient: function() {
    var _self = this;
    var cards = $('[data-component-id="' + _self.componentId + '"]').find('.js-offer-card');
    var dlImages = (window.InstallTrigger && typeof window.InstallTrigger !== 'undefined') || !!document.documentMode;
    cards.each(function() {
      /* 
        if browser is IE/FF, revert to lazy loading after page load, as opposed to 'on scroll' for loading images due to
        issues with picture + src tags. picturefill() did not correctly work here due to combination of mobileFirst, 
        mi-carousel, mi-lazyLoadImage
      */
      if(dlImages) {
        var imgSrc = $(this).find('source').filter(function(index, opt) {
          return $(opt).attr('srcset') == undefined ? $(opt).attr('data-srcset') != undefined : $(opt).attr('srcset') != undefined;
        });
        var img = $(this).find('img');
        var imgToDownload = imgSrc.attr('srcset') == undefined ? imgSrc.attr('data-srcset') : imgSrc.attr('srcset');
        var removeParam = imgToDownload.indexOf(' , ');
        if(removeParam > -1) {
          imgToDownload = imgToDownload.substring(0, removeParam);
        }
        img[0].src = '';
        var downloadingImg = new Image();
        downloadingImg.onload = function() {
          img[0].src = this.src;
          img.closest('.js-offer-card').addClass('m-gradient-overlay').removeClass('is-visibility-hidden');
        };
        downloadingImg.src = imgToDownload;
      }
      /* 
        if browser is chrome and loadPicture is defined and is a function, that means lazyLoadImage has initialized
        and executed before mobileFirst was completed and picture + src tags were ready, and images will not load correctly, 
        so we need to manually call loadPicture again with the image element
      */
      if(!dlImages && window.loadPicture && typeof window.loadPicture == 'function') {
        var imgEl = $(this).find('picture.mi-lazyLoadImage');
        loadPicture(imgEl[0]);
      }

      $(this).find('img').on('load', function() { 
        if($(this).parent().hasClass('mi-lazyLoadImage')) {
          $(this).parent().addClass('js-card-loaded');
        }
        $(this).closest('.js-offer-card').addClass('m-gradient-overlay').removeClass('is-visibility-hidden');
      });
    });
  },
  creditCardPanelClick: function() {
    var url = $(".js-card-link").attr("data-card-link");
    window.open(url);
  },
  handleTabIndex: function() {
    var _self = this;
    _self.$el.find('.m-card-wrapper').attr('tabindex', '-1');
    _self.$el.find('.m-card-wrapper.slick-active, .m-card-wrapper.m-card-static').attr('tabindex', '0');
  },
  moreOffers: function(event) {
    event.preventDefault();
    var $this = this.$el.find(event.currentTarget);
    var text = $this.children(".show-more-text").html();
    var showLessText = $("a.js-show-more").attr("data-show-less-details");
    var showMoreText = $("a.js-show-more").attr("data-show-more-details");
    var offersAndPackages = $('.tile-offers-packages .packages-wrapper:nth-of-type(1n+4)');
    var MEOSection = $('.tile-offers > .offer-wrapper ~ .offer-wrapper');
    var top = event.pageY - $(window).scrollTop();
    var parentClass = $this.parents(".tile-offers-packages").length;
    var selectedSection = parentClass > 0 ? offersAndPackages : MEOSection;
    if (text === showMoreText) {
      selectedSection.css('display', 'block');
      $this.children('.show-more-text').html(showLessText);
      $this.children('.m-more-icon').addClass('t-icon-minus');
      $("html").animate(
        {
          scrollTop: $(parentClass > 0 ? offersAndPackages : MEOSection).offset().top - top
        },0
      );
      mobileFirstPicture.changeSrcSet(this);
    }
    else {
      selectedSection.css('display', 'none');
      $this.children('.show-more-text').html(showMoreText);
      $this.children('.m-more-icon').removeClass('t-icon-minus');
    }
  }
});